import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar, BookOpen } from "lucide-react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Reveal from "@/components/site/Reveal";
import { API } from "@/lib/site";

const SITE_FALLBACK =
  "https://images.unsplash.com/photo-1560518883-ce09059eeffa?crop=entropy&cs=srgb&fm=jpg&q=80&w=800";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Blog & Tips Pinjaman Perumahan | dausREALTY";
    axios
      .get(`${API}/posts`)
      .then((r) => setPosts(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="blog-page">
      <Navbar solid />
      <main className="pt-28 md:pt-36 pb-24">
        <div className="mx-auto max-w-6xl px-6">
          <Reveal>
            <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-[#1D4ED8]">
              <BookOpen className="h-4 w-4" /> Blog & Panduan
            </span>
            <h1 className="mt-3 text-4xl sm:text-5xl font-extrabold tracking-tight text-[#0A2540]">
              Tips &amp; panduan pinjaman perumahan
            </h1>
            <p className="mt-4 max-w-2xl text-slate-600 leading-relaxed">
              Artikel berguna tentang pinjaman rumah, refinance, skim kerajaan dan
              cara meningkatkan peluang kelulusan anda di Malaysia.
            </p>
          </Reveal>

          {loading ? (
            <p className="mt-16 text-slate-500">Memuatkan artikel...</p>
          ) : posts.length === 0 ? (
            <div className="mt-16 rounded-2xl border border-dashed border-slate-300 py-20 text-center" data-testid="blog-empty">
              <BookOpen className="mx-auto h-10 w-10 text-slate-300" />
              <p className="mt-3 text-slate-500">Belum ada artikel diterbitkan.</p>
            </div>
          ) : (
            <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {posts.map((p, i) => (
                <Reveal key={p.id} delay={i * 0.08}>
                  <Link
                    to={`/blog/${p.slug}`}
                    data-testid={`blog-card-${p.slug}`}
                    className="group flex flex-col h-full rounded-2xl border border-slate-200 overflow-hidden transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-[#1D4ED8]"
                  >
                    <div className="h-44 bg-slate-100 overflow-hidden">
                      <img
                        src={p.cover_image || SITE_FALLBACK}
                        alt={p.title}
                        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                        loading="lazy"
                      />
                    </div>
                    <div className="flex flex-col flex-1 p-6">
                      <span className="flex items-center gap-1.5 text-xs text-slate-400">
                        <Calendar className="h-3.5 w-3.5" />
                        {new Date(p.created_at).toLocaleDateString("ms-MY", { year: "numeric", month: "long", day: "numeric" })}
                      </span>
                      <h2 className="mt-2 font-heading text-lg font-bold text-[#0A2540] leading-snug">{p.title}</h2>
                      <p className="mt-2 text-sm text-slate-600 leading-relaxed line-clamp-3">{p.excerpt}</p>
                      <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#1D4ED8]">
                        Baca lagi <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                      </span>
                    </div>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
